import React from "react"
import * as styles from "./content.module.scss"
import * as blockStyles from "../block/block.module.scss"
import parse from "html-react-parser";

const Content = ({content}) => {

    /*
    contentCta {
      target
      title
      url
    }
    contentDescription
    contentTitle
    */
    return (
        <section className={styles.contentSection}>
            <div className="grid-container-wrap">
                <div className={`${blockStyles.blockItem} block-normal`}>
                    <div className="grid-container">
                        <div className="grid-colstart-2-xl-min grid-colend-11-xl-min">
                            <div className="grid-container">

                                {content.map((columnContent, key) => {
                                    return <div key={key} className="grid-col-6-sm-min">
                                        <h3 className={blockStyles.blockTitle}>{columnContent.contentTitle}</h3>
                                        {columnContent.contentDescription &&
                                        parse(columnContent.contentDescription)
                                        }
                                        {key + 1 !== content.length &&
                                        <hr className="hide-sm-min"/>
                                        }
                                    </div>
                                })}


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Content